import { authenticationAPI } from './../apis/authentication-api';

export const login = (email: string, password: string) => {
  const res = authenticationAPI.login({ email, password });
  return res;
};
